import { LotTableRowSchema } from "@redotech/redo-fulfillment-common/lot/lot-table-row";
import { productIdFormat } from "@redotech/redo-product-id";
import {
  AdvancedFilterDataSchema,
  FilterGroupSchema,
} from "@redotech/redo-views-common/advanced-filters/advanced-filter-data";
import {
  OpensearchPaginationCursorSchema,
  SortDirection,
} from "@redotech/redo-views-common/table";
import { VALID_PAGE_SIZES } from "@redotech/redo-views-common/views";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getLots = {
  name: "getLots" as const,
  input: z.object({
    pageNumber: z.number(),
    pageSize: z
      .number()
      .refine((value) => VALID_PAGE_SIZES.includes(value as any), {
        message: `pageSize must be one of: ${VALID_PAGE_SIZES.join(", ")}`,
      }),
    search: z.string().nullish(),
    sort: z
      .object({ key: z.string(), direction: createEnum(SortDirection) })
      .nullish(),
    filterGroup: FilterGroupSchema.nullish(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).default([]),
    opensearchPaginationCursor: OpensearchPaginationCursorSchema.nullish(),
    productIdCluster: productIdFormat.schema.nullish(),
  }),
  output: z.object({
    lots: z.array(LotTableRowSchema),
    opensearchPaginationCursor: OpensearchPaginationCursorSchema.nullish(),
  }),
};

export const getLotsCount = {
  name: "getLotsCount" as const,
  input: z.object({
    search: z.string().nullish(),
    filterGroup: FilterGroupSchema.nullish(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).default([]),
    productIdCluster: productIdFormat.schema.nullish(),
  }),
  output: z.object({ total: z.number() }),
};

export const getLotProducts = {
  name: "getLotProducts" as const,
  input: z.object({
    field: z.enum(["title", "sku"]).default("title"),
    search: z.string().nullish(),
    limit: z.number().int().positive().max(500).default(100),
  }),
  output: z.object({ values: z.array(z.string()) }),
};
